var _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgBigRoundIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 61,
    height: 61,
    viewBox: "0 0 61 61",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_6048_52443)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0.5 21.9288V39.0712C0.5 50.9062 10.0938 60.5 21.9288 60.5H39.0712C50.9062 60.5 60.5 50.9062 60.5 39.0712V21.9288C60.5 10.0938 50.9062 0.5 39.0712 0.5H21.9288C10.0938 0.5 0.5 10.0938 0.5 21.9288ZM21.9288 9.07171H39.0712C46.1724 9.07171 51.9283 14.8276 51.9283 21.9288V39.0712C51.9283 46.1724 46.1724 51.9283 39.0712 51.9283H21.9288C14.8276 51.9283 9.07171 46.1724 9.07171 39.0712V21.9288C9.07171 14.8276 14.8276 9.07171 21.9288 9.07171Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M30.4977 43.3567C37.5985 43.3567 43.3548 37.6004 43.3548 30.4997C43.3548 23.3989 37.5985 17.6426 30.4977 17.6426C23.3969 17.6426 17.6406 23.3989 17.6406 30.4997C17.6406 37.6004 23.3969 43.3567 30.4977 43.3567Z",
    fill: "black"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_6048_52443"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 60,
    height: 60,
    fill: "white",
    transform: "translate(0.5 0.5)"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBigRoundIcon);
export default __webpack_public_path__ + "static/media/big-round-icon.0686143e824bf7e6a81d9c7b1d262892.svg";
export { ForwardRef as ReactComponent };